//Reset data
export const RESET = "SECTEUR_UPDATE_RESET"

export const SET_IS_UPDATED = "SECTEUR_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "SECTEUR_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "SECTEUR_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "SECTEUR_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "SECTEUR_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "SECTEUR_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "SECTEUR_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "SECTEUR_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "SECTEUR_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "SECTEUR_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "SECTEUR_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "SECTEUR_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "SECTEUR_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "SECTEUR_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "SECTEUR_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "SECTEUR_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "SECTEUR_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "SECTEUR_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "SECTEUR_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "SECTEUR_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "SECTEUR_UPDATE_SET_MODAL_TYPE"